const TooltipPosition = ({
  position,
  arrowPosition,
  direction,
  contentWidth,
  offsetTooltip
}) => {
  const {
    rect: { top, left, right, bottom },
    scrollTop,
    scrollLeft
  } = position;
  const leftOffset = offsetTooltip.left || 0;
  const rightAlignment = right - contentWidth - leftOffset;
  const leftAlignment = left + leftOffset;

  const adjustedTop = direction === 'down'
    ? top - 15 + scrollTop
    : bottom + 15 + scrollTop;
  const adjustedLeft = arrowPosition === 'right'
    ? rightAlignment + scrollLeft
    : leftAlignment + scrollLeft;

  const translation = direction === 'down'
    ? 'transform: translateY(-100%);'
    : '';

  return `
    top: ${Math.max(0, adjustedTop)}px;
    left: ${Math.max(0, adjustedLeft)}px;
    ${translation}
  `;
};

export default TooltipPosition;
